import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './index.scss';
import pubsub from "@viewlift/pubsub";
import { ANALYTICS } from "../../../helpers/analyticsMap";
import { checkForHBA, getFlowSteps, handleNewTabLoader } from "../../../helpers";
import { ANALYTICSEVENTS } from "../../../OnBoarding-V2/LoginV2/Helpers/analyticsMap";
import { fetchCurrentPlan } from "../../../OnBoarding-V2/PlansWrapper/helper"
import { flowSteps } from "../../../OnBoarding-V2/helper";
import { getFontsStyles } from "../../TrayModules/Helper/helper";
import { getStorageItem, setStorageItem } from "../../../helpers/storageManager";

export const SubscribeButton = ({handleLoader, layoutSettings, dataTest='' }) => {
    const [store, setStore] = useState({});
    const navigate = useNavigate();
    const { subscribeNowCta} = getFontsStyles( layoutSettings?.fontSetting, layoutSettings?.settings);
    const {subscribeNowCtaBgColor,subscribeNowCtaBorderColor,subscribeNowCtaTextColor} = layoutSettings?.settings || {};
    const subscribeNowCtaStyle = {
        backgroundColor: subscribeNowCtaBgColor,
        borderColor: subscribeNowCtaBorderColor,
        color: subscribeNowCtaTextColor
    }

    /*useEffect(() => { // store is not used anyehere
        localforage.getItem('AuthenticationStore')
            .then((store) => {
                setStore(store);
            })
            .catch((err) => {
                console.log(err)
            });
    }, []);*/

    const handleSubscribeHandler = async()=>{
        let plan = fetchCurrentPlan()
        let pageData = window?.page_data?.page
        let pageId = pageData?.id
        let pageTitle = pageData?.title
        let eventdata = {
            "pageUrl": window?.location.href,
            "pgName" : pageTitle,
            "pgId" : pageId,
            "modType" : layoutSettings?.type,
            "modID": layoutSettings?.id,
            "monetizationType": plan?.type || "",
            "planName" : plan?.title  || "", 
            "planID" : plan?.planId  || "",
            "stepsCompleted": flowSteps,
        }   
            sessionStorage.setItem('checkoutInitPageData', JSON.stringify({"pageUrl": window?.location.href, "pgName" : pageTitle, "pgId" : pageId}))
            pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_INIT, data: eventdata});
            pubsub.publish('user-analytics',{ename:ANALYTICS.SUBSCRIBE});
            setStorageItem('transactionData',{isPurchase : false, purchaseType : "Svod"})
            sessionStorage.removeItem("contentPlanIds")
            sessionStorage.removeItem("toShowTve")
            handleLoader();
            handleNewTabLoader()
            const path = await isCheckoutAvailable();
            navigate(path);
            return true
    };

    const isCheckoutAvailable = async () => {
        let compliance = window?.app_data?.site?.settings?.compliance;
        let flowUrls = getFlowSteps(compliance);
        if (flowUrls?.includes("/checkout")) {
            return "/checkout";
        } else {
            let userInfo = getStorageItem("AuthenticationStore");
            if (userInfo && userInfo?.user?.userId) {
                let isHba = await checkForHBA();
                if (!isHba) return '/locate';
            }

            return "/viewplans";
        }
    };

    return (
        <>
            <button
                aria-label="subscribe now"
                className="subscribeBtn site-cta-background-color site-cta-color"
                onClick={handleSubscribeHandler}
                data-test={dataTest}
                style={{...subscribeNowCta, ...subscribeNowCtaStyle}}
            >
                {window?.app_data?.appcmsPlatform?.navigation?.settings?.primaryCta?.ctaText || 'Subscribe Now'}
            </button>
        </>
    );
};
